import styled from 'styled-components'
import Icon from './Icon'

const ListIcon = styled(Icon).attrs({
  type: 'list',
})``

export default ListIcon
